import { styled, alpha } from "@mui/material/styles";
import {
    Box as MuiBox
} from "@mui/material";

export const MessageRibbonOverlayContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "stretch",
    position: "relative",
    overflow: "hidden",
    minHeight: "2.6rem",

    backgroundColor: theme.colors["yellow.300"],
}));

export const StripesLeft = styled("div")(({ theme }) => ({
    "&::before, &::after": {
        content: '""',
        position: "absolute",
        backgroundColor: "black",
        width: "0.6rem",
        height: "11rem",
        transform: "rotate(-45deg)",

        "@media (min-width: 600px) and (max-width: 992px) ": {
            width: "0.5rem",
        }
    },
    "&::before": {
        left: "20px",
        top: -50,
    },
    "&::after": {
        left: "50px",
        top: -50,
    },
}));

export const StripesRight = styled("div")(({ theme }) => ({
    "&::before, &::after": {
        content: '""',
        position: "absolute",
        backgroundColor: "black",
        width: "0.6rem",
        height: "13rem",
        transform: "rotate(-45deg)",

        "@media (min-width: 600px) and (max-width: 992px) ": {
            width: "0.5rem",
        }
    },
    "&::before": {
        right: -20,
        top: -50,

        "@media (min-width: 600px) and (max-width: 992px) ": {
            right: -15,
        }
    },
    "&::after": {
        right: 10,
        top: -50,

        "@media (min-width: 600px) and (max-width: 992px) ": {
            right: 15,
        }
    },
}));

export const CustomMessageRibbonOverlay = styled(MuiBox)(({theme}) => ({
    display: "flex",
    flexDirection: "column",
    alignSelf: "stretch",
    alignItems: "center",
    justifyContent: "center",
    padding: `${theme.space._200}`,
    maxWidth: "70%",

    color: theme.colors["neutral.950"],
    fontFamily: theme.fonts.default,
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.slim,
}));